import { motion } from "framer-motion";
import { Sparkles, X } from "lucide-react";

export default function ChatHeader({ onClose }) {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-violet-700 via-fuchsia-600 to-pink-600 px-5 py-3">

      {/* Background Glow */}
      <motion.div
        animate={{ x: [-40, 40, -40] }}
        transition={{ repeat: Infinity, duration: 8, ease: "linear" }}
        className="absolute -top-10 -left-10 h-32 w-32 rounded-full bg-white/10 blur-3xl"
      />

      <motion.div
        animate={{ x: [40, -40, 40] }}
        transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
        className="absolute -bottom-10 -right-10 h-36 w-36 rounded-full bg-white/10 blur-3xl"
      />

      <div className="relative flex items-center justify-between">

        {/* Left */}
        <div className="flex items-center gap-4">

          {/* Avatar */}
          <div className="relative flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15 backdrop-blur-xl border border-white/20">

            <Sparkles size={18} className="text-white" />

            {/* Online Dot */}
            <span className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full border-2 border-white bg-green-400"></span>
          </div>

          {/* Title */}
          <div>

            <h3 className="text-base font-bold text-white">
              GrowX Assistant
            </h3>

            <p className="flex items-center gap-2 text-xs text-white/80">
              <span className="h-2 w-2 rounded-full bg-green-400"></span>
              Online • Usually replies instantly
            </p>

          </div>

        </div>

        {/* Close Button */}
        <motion.button
          whileHover={{ rotate: 90, scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={onClose}
          className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10 text-white transition hover:bg-white/20 ms-2"
        >
          <X size={16} />
        </motion.button>

      </div>

    </div>
  );
}